export default __webpack_public_path__ + "static/media/present-a-new-project-idea.21033d83.svg";